import React, {useEffect, useState} from 'react';
import { Badge, Tooltip } from "antd";

import {store} from "@redux/store";
import {api} from "@redux/api";
import {useSelector} from "react-redux";

import { ENV } from '@config/env'
import {WorkerCommentTooltip} from "@containers/facility/Workorder/WorkorderTooltip";
const { wsURL } = ENV;

const RelatedWorkorderNotification = (record) => {
    const facility_id = store.getState().Facility.selected.Id;

    const [workorderNotification, setWorkorderNotification] = useState(record.record.unread_notifications_count);
    const [workorderId, setWorkorderId] = useState(record.record.id);
    const [prevDrawerId, setPrevDrawerId] = useState(record.record.id)
    const user_id = useSelector(state => state.Auth.userId);
    const drawer = useSelector(state => state.EditableTable.drawer);
    const drawer_id = useSelector(state => state.EditableTable.id);

    const setReadComment = (comment_id) => {
        if (comment_id) {
            api.bulkDeleteWorkerorderNotifications(comment_id, {status: 'read'})
                .then(response => {
                    console.log(`Comment ${comment_id} marked as read`);
                    // Update the local state
                    setWorkorderNotification(0);
                })
                .catch(error => console.error('Error updating notification status:', error));
        } else {
            console.error('No notification ID provided');
        }
    };

    useEffect(() => {
        setPrevDrawerId(drawer_id)
    }, [drawer_id])


    useEffect(() => {
        if (workorderId === prevDrawerId && drawer === true) {
            console.log('read::', workorderId, drawer, prevDrawerId)
            // Call setReadComment when the previous value of drawer was true and the new value is false
            setReadComment(workorderId);
        }
    }, [drawer, workorderId, prevDrawerId]);

    useEffect(() => {
        console.log('test')
        const ws = new WebSocket(wsURL + 'kpiworkordercomment/?user_id=' + user_id + '&facility_id=' + facility_id + '&parent_id=' + record.record.id);

        ws.onopen = () => {
            console.log('Connected to websocket server');
        };

        ws.onmessage = e => {

            const data = JSON.parse(e.data);
            console.log('kpiworkordercomment data: ', data)
            if (data.parent_id === record.record.id) {
                setWorkorderNotification(prevNotification => (prevNotification + 1));
            }
        };

        // ws.onerror = e => {
        //     console.error('WebSocket error: ', e);
        // };
        //
        // ws.onclose = e => {
        //     console.error('WebSocket closed: ', e);
        // };

        // Clean up on unmount
        return () => {
            ws.close();
        };
    }, [facility_id, record.record.id, user_id, drawer, drawer_id]);


    return (
        <Tooltip placement={'topLeft'} trigger={['click']} overlayStyle={{maxWidth: '60rem'}}
                 onOpenChange={(open) => open && setReadComment(record.record.id)}
                 title={WorkerCommentTooltip(record.record.id, record.record.equipment)} color={'lightgrey'}>
            <Badge count={workorderNotification}>
                <i className="fas fa-comment-dots text-primary text-2xl "
                   style={{color: '#faad14', fontSize: '23px'}}></i>
            </Badge>
        </Tooltip>
    );
}

export default RelatedWorkorderNotification;
